'use client';

import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';
import { cn } from 'cn';
type TooltipProviderProps = TooltipPrimitive.Provider.Props;
export function TooltipProvider(props) {
  const $ = _c(6);
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      delay: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
  } else {
    rest = $[1];
    t0 = $[2];
  }
  const delay = t0 === undefined ? 0 : t0;
  let t1;
  if ($[3] !== delay || $[4] !== rest) {
    t1 = <TooltipPrimitive.Provider data-slot="tooltip-provider" delay={delay} {...rest} />;
    $[3] = delay;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
type TooltipProps = TooltipPrimitive.Root.Props;
export function Tooltip(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type TooltipTriggerProps = TooltipPrimitive.Trigger.Props;
export function TooltipTrigger(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type TooltipContentProps = TooltipPrimitive.Popup.Props & Pick<TooltipPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>;
export function TooltipContent(props) {
  const $ = _c(21);
  let children;
  let className;
  let rest;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    ({
      className,
      side: t0,
      sideOffset: t1,
      align: t2,
      alignOffset: t3,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const side = t0 === undefined ? "top" : t0;
  const sideOffset = t1 === undefined ? 4 : t1;
  const align = t2 === undefined ? "center" : t2;
  const alignOffset = t3 === undefined ? 0 : t3;
  let t4;
  if ($[8] !== className) {
    t4 = cn("z-50 inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-2xl bg-foreground px-3 py-1.5 text-xs text-background", "has-data-[slot=kbd]:pr-1.5", "data-[side=bottom]:slide-in-from-top-2", "data-[side=inline-end]:slide-in-from-left-2", "data-[side=inline-start]:slide-in-from-right-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", "**:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-4xl", "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95", "data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95", "data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TooltipPrimitive.Arrow className="z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-xs bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:translate-x-[1.5px] data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:translate-x-[-1.5px] data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:translate-x-[-1.5px] data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:translate-x-[1.5px] data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== rest || $[13] !== t4) {
    t6 = <TooltipPrimitive.Popup data-slot="tooltip-content" className={t4} {...rest}>{children}{t5}</TooltipPrimitive.Popup>;
    $[11] = children;
    $[12] = rest;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== align || $[16] !== alignOffset || $[17] !== side || $[18] !== sideOffset || $[19] !== t6) {
    t7 = <TooltipPrimitive.Portal><TooltipPrimitive.Positioner align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} className="isolate z-50">{t6}</TooltipPrimitive.Positioner></TooltipPrimitive.Portal>;
    $[15] = align;
    $[16] = alignOffset;
    $[17] = side;
    $[18] = sideOffset;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}